import { Children, cloneElement, useCallback, useEffect } from 'react'

import useUIContext from 'context/ui'

const CursorHover = ({ children, icon }) => {
  const setCursorIcon = useUIContext((s) => s.setCursorIcon)

  useEffect(() => {
    return () => {
      if (useUIContext.getState().cursorIcon === icon) {
        setCursorIcon(null)
      }
    }
  }, [icon, setCursorIcon])

  const setIcon = useCallback(() => setCursorIcon(icon), [icon, setCursorIcon])
  const clearIcon = useCallback(() => setCursorIcon(null), [setCursorIcon])

  Children.only(children)
  return Children.map(children, (child) =>
    cloneElement(child, { onMouseEnter: setIcon, onMouseLeave: clearIcon, onMouseMove: setIcon }),
  )
}

export default CursorHover
